import { repository } from 'redux-scaffolding-ts'
import { DataStore } from 'src/core/stores/dataStore'
import HttpService from '../../core/services/http.service'
import { container } from '../../inversify.config'

export interface NotificationItem {
    id: string
    userId: string
    name: string
    description: string
    type: string
    data: any
    taskId: string
    readed: boolean
    creationTime: Date
}

export interface TaskItem {
    id: string
    startTime: Date
    endTime: Date
    createdById: string
    status: string
    result: any
    //Json
    request: any
    type: string
}

@repository('@@NOTIFICATIONS', 'notification.item')
export class NotificationItemStore extends DataStore<NotificationItem> {
    baseUrl: string = `${process.env.PUBLIC_URL}/api/v1/admin/notifications`;

    constructor() {
        super('Notifications', {
            count: 0,
            isBusy: false,
            items: [],
            result: undefined,
            discard: item => { }
        }, container)
    }


    public async SetReadStatus() {
        let httpService = this.container.get<HttpService>(HttpService)
        await httpService.put(this.baseUrl, {})
    }
    public async delete(id: string) {
        let httpService = this.container.get<HttpService>(HttpService)
        await httpService.delete(this.baseUrl + '/' + id, {})
    }
    public async deleteAll() {
        let httpService = this.container.get<HttpService>(HttpService)
        await httpService.delete(this.baseUrl, {})
    }
}


@repository('@@Task', 'task.item')
export class TaskItemStore extends DataStore<NotificationItem> {
    baseUrl: string = `${process.env.PUBLIC_URL}/api/v1/admin/tasks/active`;

    constructor() {
        super('Tasks', {
            count: 0,
            isBusy: false,
            items: [],
            result: undefined,
            discard: item => { }
        }, container)
    }

}
